import { render, staticRenderFns } from "./postil.vue?vue&type=template&id=f433a352&scoped=true&"
import script from "./postil.vue?vue&type=script&lang=js&"
export * from "./postil.vue?vue&type=script&lang=js&"
import style0 from "./postil.vue?vue&type=style&index=0&id=f433a352&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f433a352",
  null
  
)

export default component.exports